<template>
    <div class="p-4">
        Coming Soon...
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>

</style>